import { siteApiSlice } from "../../../../app/siteApiSlice";
import NamedEntity from "../../../../interfaces/NamedEntity";
import { AdminReportsResponse, AdminReportsRowBase } from "../adminReportsApiSlice";

interface PromptRowBase {
	essayCount: number;
	draftCount: number;
	averageNumberOfDraftsPerEssay: number;
	averageDevelopment: number;
	averageOrganization: number;
	averageStyle: number;
	averageWordChoice: number;
	averageSentenceStructure: number;
	averageConventions: number;
	averageScore: number;
}

export interface UsageAndPerformanceByPromptRow extends PromptRowBase {
	promptId: number;
	promptName: string;
}

export interface UsageAndPerformanceByPromptReponse {
	lastUpdateDate?: Date;
	response: AdminReportsResponse<UsageAndPerformanceByPromptRow>;
}

export interface PromptUsageAndPerformanceByLevelRow extends AdminReportsRowBase, PromptRowBase {
	mostRecentSubmission: Date;
}

export interface PromptUsageAndPerformanceByLevelReponse {
	lastUpdateDate?: Date;
	response: AdminReportsResponse<PromptUsageAndPerformanceByLevelRow>;
}

export const adminPromptReportApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		getPromptOptionsForReports: build.query<
			NamedEntity[],
			{ districtId?: number; schoolId?: number }
		>({
			query: (arg) => {
				const { districtId, schoolId } = arg;
				return {
					url: `/AdminReports/GetPromptsForSpaReports`,
					params: { districtId, schoolId },
				};
			},
		}),
		promptUsageAndPerformance: build.query<
			UsageAndPerformanceByPromptReponse,
			{ districtId?: number; schoolId?: number }
		>({
			query: (arg) => {
				const { districtId, schoolId } = arg;
				return {
					url: `/AdminReports/PromptReportAjaxHandler`,
					params: { districtId, schoolId },
				};
			},
		}),
		promptUsageAndPerformanceByLevel: build.query<
			PromptUsageAndPerformanceByLevelReponse,
			{ promptId: number; districtId?: number; schoolId?: number }
		>({
			query: (arg) => {
				const { promptId, districtId, schoolId } = arg;
				return {
					url: `/AdminReports/PromptResultsAjaxHandler`,
					params: { promptId, districtId, schoolId },
				};
			},
		}),
	}),
});

export const {
	useLazyGetPromptOptionsForReportsQuery,
	useLazyPromptUsageAndPerformanceQuery,
	useLazyPromptUsageAndPerformanceByLevelQuery,
} = adminPromptReportApiSlice;
